import { Component, OnInit, Input, Inject } from "@angular/core";
import { BaseFormComponent } from "../../pages/_core/base-form.component";
import { MyToasterService } from "../../../services/my-toaster.service";
import { ActivatedRoute } from "@angular/router";
import { RoutinesService } from "../../../services/routines.service";
import { LoadingService } from "../../../services/loading.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UsersAPI } from "../../../api/users.api";
import { ProcessAPI } from "../../../api/process.api";

@Component({
  selector: "app-field-edit",
  templateUrl: "./field-edit.component.html",
  styleUrls: ["./field-edit.component.scss"],
})
export class FieldEditComponent extends BaseFormComponent implements OnInit {
  constructor(
    @Inject(MyToasterService) myToaster: MyToasterService,
    @Inject(ActivatedRoute) route: ActivatedRoute,
    @Inject(RoutinesService) routinesService: RoutinesService,
    @Inject(LoadingService) loadingService: LoadingService,
    private activeModal: NgbActiveModal,
    private userAPI: UsersAPI,
    private processAPI: ProcessAPI
  ) {
    super(myToaster, route, routinesService, loadingService);
  }
  public field: string;
  public dados: any;
  public routine: string = "process";
  public msg: string = "";
  public usersArray;
  public processService;

  public async _init() {}

  protected async _save() {}
  /**
   * onSubmit
   *
   * Método chamado na tentativa de submissão do formulário
   *
   * @protected
   * @author Nicolas Aoki
   * @since  11/2019
   * @param  {object}
   * @return {void}
   */
  public async onSubmit(form?) {
    try {
      if (this.routine == "process") {
        if (this.dados.UsuarioSupervisor) {
          await this.updateSupervisor();
        } else {
          this.myToaster.showErrorToast("É necessário escolher um usuário.");
        }
      }
      if (this.routine == "users") {
        this.updateLead();
      }
      // //Aciona o recarregamento da varialem em process-header
      // //para fazer uma requisicao e mostrar a incorporadora adicionada no header
      // this.activeModal.close();
      // this.myToaster.hideLoading();
    } catch (err) {
      this.myToaster.hideLoading();
      this.myToaster.showErrorToast(
        "Não foi possivel efetuar a transação",
        err
      );
    }
  }
  async updateSupervisor() {
    this.myToaster.showLoading("Vinculando dados...");

    //Procura nome do usuario dentro do array atraves do ID escolhido no template
    let user = this.usersArray.filter((value) => {
      return value.id == this.dados.UsuarioSupervisor;
    });

    //Incremeta na tratativa a alteração do supervisor
    this.dados.StatusProcessoId = this.processService.processo.StatusProcessoId;
    this.dados.ProcessoId = this.processService.id;
    this.dados.Comentario =
      "Usuario: " +
      user[0].nome +
      " ID: " +
      user[0].id +
      "  está supervisionando o processo";

    await this.processAPI
      .save(this.dados)
      .then(() => {
        this.myToaster.hideLoading();
        this.activeModal.close();
      })
      .catch((err) => {
        this.myToaster.showErrorToast(
          "Não foi possivel efetuar a transação",
          err
        );
      });
  }
  async updateLead() {}
  async getUsers(nome) {
    this.usersArray = [];

    await this.userAPI.getByUserName(nome).then((res) => {
      let item = res.data;
      item.forEach((element) => {
        this.usersArray.push({
          nome: element.Nome,
          id: element.UsuarioId,
          email: element.Email,
        });
      });
    });
  }

  async getSupervisorCandidates(nome) {
    this.usersArray = [];

    await this.userAPI.getSupervisorCandiates(nome).then((res) => {
      let item = res.data;
      item.forEach((element) => {
        this.usersArray.push({
          nome: element.Nome,
          id: element.UsuarioId,
          email: element.Email,
        });
      });
    });
  }

  public close() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/field-edit/field-edit.component.ts